import { render } from "./RightBlock.vue?vue&type=template&id=0c32b38e&ts=true"
import script from "./RightBlock.vue?vue&type=script&lang=ts"
export * from "./RightBlock.vue?vue&type=script&lang=ts"

import "./RightBlock.vue?vue&type=style&index=0&id=0c32b38e&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__